import { render } from "./App.vue?vue&type=template&id=ca5ce836"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ca5ce836&lang=css"

import exportComponent from "/data/samsungshop/nps-prd/web/questionnaire/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__